import { useMemo } from 'react';

import { useIntl } from 'react-intl';

import Grid from '@mui/material/Grid2';
import Typography from '@mui/material/Typography';

import { shortWeekFormat, toMoment } from 'src/utils/datetime';

import type { DefaultTheme } from '@mui/styles';

import messages from '../../messages';

const gridSx = (theme: DefaultTheme) => ({
  display: 'grid',
  alignItems: 'center',
  justifyContent: 'center',
  height: theme.spacing(5),
  gridTemplateColumns: 'repeat(8, 1fr)',
  backgroundColor: theme.palette.grey[100],
  borderBottom: `thin solid ${theme.palette.divider}`,
});

interface Props {
  monthIndex: number;
  months: Array<string>;
}

export default function JobCalendarWeekdays({ monthIndex, months }: Props) {
  const formatMessage = useIntl();

  const weekdaysContent = useMemo(() => {
    const month = months?.[monthIndex];
    if (!month) return null;

    const currDay = toMoment(month)?.startOf('month').startOf('week');
    if (!currDay) return null;

    const firstWeek = currDay.week();
    const weekdays: string[] = [];

    while (firstWeek === currDay.week()) {
      weekdays.push(currDay.format(shortWeekFormat));
      currDay.add(1, 'day');
    }

    return weekdays;
  }, [months, monthIndex]);

  if (!weekdaysContent) return null;

  return (
    <Grid size={12} container sx={gridSx}>
      {weekdaysContent.map((day) => (
        <Typography key={day} variant="body2" textAlign="center">
          {day}
        </Typography>
      ))}

      <Typography variant="body2" textAlign="center">
        {formatMessage.formatMessage(messages.weekStatsColumnLabel)}
      </Typography>
    </Grid>
  );
}
